import React, { useEffect, useState } from "react";

// hooks
import { useRedux } from "../../../hooks/index";
import { createSelector } from "reselect";
// components
import Loader from "../../../components/Loader";
import FormInput from "../../../components/FormInput";
import AppSimpleBar from "../../../components/AppSimpleBar";

import { Tabs, Tab, Card, CardHeader, CardBody, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// validations
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

// actions
import { getProfileDetails } from "../../../redux/actions";
import { registerUserAccount } from "../../../services/auth";
import UserInfo from "./UserInfo";
import Logo from "./Logo";
import LanguageSwitcher from "../../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

interface IndexProps {}
const Profile = (props: IndexProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [key, setKey] = React.useState<string | null>("user_info");

  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Profile,
    state => ({
      profileDetails: state.profileDetails,
      getProfileLoading: state.getProfileLoading,
      isProfileFetched: state.isProfileFetched,
    }),
  );

  interface RegisterFormValues {
    full_name: string;
    email: string;
    password: string;
  }
  // Inside your component
  const { profileDetails, getProfileLoading, isProfileFetched } =
    useAppSelector(errorData);

  // get user profile details
  useEffect(() => {
    dispatch(getProfileDetails());
  }, [dispatch]);

  const resolver = yupResolver(
    yup.object().shape({
      invoice_issuer_name: yup
        .string()
        .required("Please enter your company or person name."),
      road: yup.string().required("Please enter your road."),
      zip_code: yup.string().required("Please enter your zip code"),
      location: yup.string().required("Please enter your location"),
      land: yup.string().required("Please enter your land"),
      vat_id: yup.string().required("Please enter your VAT ID"),
      contact_person: yup.string().required("Please enter the contact person"),
      phone_number: yup
        .string()
        .matches(/^[0-9]{10,15}$/, "Please enter a valid mobile number.")
        .required("Please enter your mobile number."),
      email: yup
        .string()
        .email("This value should be a valid email.")
        .required("Please enter an email."),
    }),
  );

  const defaultValues: any = {};

  const methods = useForm({ defaultValues, resolver });
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  const onSubmitForm = async (values: RegisterFormValues) => {
    setIsSubmitting(true);
    try {
      const addtionalData = {
        full_name: values.full_name,
      };
      const response = await registerUserAccount(
        values.email,
        values.password,
        addtionalData,
      );

      if (response.success) {
        setAlertMessage("User registered successfully!");
        setAlertType("success");
      } else {
        if (
          response.message == "Firebase: Error (auth/email-already-in-use)."
        ) {
          setAlertMessage("User was already registered.");
        } else {
          setAlertMessage(
            response.message || "Registration failed. Please try again.",
          );
        }
        setAlertType("danger");
      }
    } catch (error) {
      setAlertMessage(
        "An error occurred while registering. Please try again later.",
      );
      setAlertType("danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to toggle visibility
  const handleToggle = () => {
    setIsVisible(!isVisible);
  };

  const handleGoToSubscriptionPage = () => {
    navigate("/subscription");
  };

  return (
    <div className="position-relative right-panel">
      <div className="sticky-top bg-white shadow-sm w-100 p-3 d-flex justify-content-between align-items-center z-index-100">
        <span className="mb-0 default-text" style={{ fontWeight: "500" }}>
          {t("Profile")}
        </span>
        <span className="d-flex gap-3">
          <LanguageSwitcher />
          <Button variant="danger" onClick={handleGoToSubscriptionPage}>
            {t("Unlock Pro")}
          </Button>
        </span>
      </div>
      <div id="top_tab" className="py-3  px-4">
        <div id="breadcrumb" className="d-flex gap-2 my-3">
          <i className="bx bx-home font-size-22"></i>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 h-5 w-5"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>
            <a style={{ fontWeight: "500" }}> {t("Profile")}</a>
          </span>
        </div>
        <Tabs
          id="controlled-tab-example"
          activeKey={key ?? undefined} // Convert null to undefined for compatibility
          onSelect={k => setKey(k)}
          className="mb-3 pt-3"
        >
          <Tab
            eventKey="user_info"
            title={
              <span
                style={
                  key === "user_info"
                    ? { color: "#ff5722", fontWeight: "bold" }
                    : { color: "rgb(12 39 68)", fontWeight: "bold" }
                }
              >
                {t("User Info")}
              </span>
            }
          >
            <UserInfo />
          </Tab>
          <Tab
            eventKey="logo"
            title={
              <span
                style={
                  key === "logo"
                    ? { color: "#ff5722", fontWeight: "bold" }
                    : { color: "rgb(12 39 68)", fontWeight: "bold" }
                }
              >
                {t("Logo")}
              </span>
            }
          >
            <Logo />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Profile;
